/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Keep_Vo_TracksInputs */



/**
* | output |
* | --- |
* | "Export VO Track(s)" |
*
* @param {Audio_Description_Export_Keep_Vo_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_keep_vo_tracks = /** @type {((inputs?: Audio_Description_Export_Keep_Vo_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Keep_Vo_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la ou les pistes VO")
	if (locale === "de") return /** @type {LocalizedString} */ ("VO-Spur(en) exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta tracce VO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт аудиодорожек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar pistas VO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出配音轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VOトラックをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉयस ओवर ट्रैक निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar faixa(s) de narração")
	return /** @type {LocalizedString} */ ("Export VO Track(s)")
});